export default {
	URL: 'https://api-absul.infinitum-ti.com',
	API_URL: 'https://api-absul.infinitum-ti.com/api',
	OAPI_URL: 'https://api-absul.infinitum-ti.com/oapi',
	// URL: 'http://localhost:5454',
	// API_URL: 'http://localhost:5454/api',
	// OAPI_URL: 'http://localhost:5454/oapi',
}
